///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.select_item = abcsetup.rfq.bid_requests.select_item || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.select_item = {
    init: function () {
        abcsetup.setTitle('Edit RFQ Event');

        // AB Item checkbox checked
        $(document).on('change', 'input:checkbox', function() {
            $(this).removeClass('selected');

            if ($(this).prop('checked')) {
                window.opener.abcsetup.rfq.bid_requests.common.items.push({
                    id: $(this).val(),
                    text: '(' + $(this).val() + ') ' + $(this).data('name')
                });

            } else {
                var _val = $(this).val();
                window.opener.abcsetup.rfq.bid_requests.common.items = window.opener.abcsetup.rfq.bid_requests.common.items.filter(function(obj) {
                    return (obj.id !== _val);
                });

                // We need to keep track of items to remove
                window.opener.abcsetup.rfq.bid_requests.common.removeItems.push($(this).val());
            }
        });

        // Attach button clicked
        $(document).on('click', '.btn-attach', function() {
            // Remove items (if necessary)
            $(window.opener.abcsetup.rfq.bid_requests.common.removeItems).each(function() {
                window.opener.abcsetup.rfq.bid_requests.common.searchVendor(this.replace(/['"]+/g, ''),'unselect');
                $("#items", window.opener.document).find("option[value=" + this + "]").remove().trigger("change");
            });

            // Attach the newly selected items
            $(window.opener.abcsetup.rfq.bid_requests.common.items).each(function() {
                // Toggle the existing item or add it
                if ($("#items", window.opener.document).find("option[value=" + this.id + "]").length) {
                    $("#items", window.opener.document).find("option[value=" + this.id + "]").prop('selected', true).trigger('change');
                } else {
                    var newOption = new Option(this.text, this.id, true, true);
                    $('#items', window.opener.document).append(newOption).trigger('change');
                    window.opener.abcsetup.rfq.bid_requests.common.searchVendor(this.id,'select');
                }
            });

            $('#items', window.opener.document).trigger('change');
            window.opener.abcsetup.rfq.bid_requests.common.updateDeadNetPricing();
            window.opener.abcsetup.rfq.bid_requests.common.updateAnnualUsage();
            window.opener.abcsetup.rfq.bid_requests.common.updateQtyNeeded();
            window.opener.abcsetup.rfq.bid_requests.common.updateAdditionalUsage();
            window.opener.abcsetup.rfq.bid_requests.common.updateIncumbentSuppliers();
            window.close();
        });

        // Attach all button clicked
        $(document).on('click', '.btn-attach-all', function() {
            abcsetup.blockUI(true);

            var _link = $(this);
            _link.css("cursor", "progress");

            // Get all the records in the current datatable
            abcsetup.datatables.exportAjaxTable('RECORDS', abcsetup.datatables.table, false);
            axios.post('/api/coupa/datatable?action=EXPORT_RECORDS', $('#datatables_download').serialize()).then(response => {
                _link.css('cursor', 'pointer');

                // Remove items (if necessary)
                $("#items", window.opener.document).find("option").remove().trigger("change");

                if (response.data && response.data.data) {
                    $(response.data.data).each(function() {
                        var checkBox = $(this[0]).find('input[type=checkbox]');
                        var sap = checkBox.val();
                        var name = checkBox.data('name');

                        var newOption = new Option(name, sap, true, true);
                        $('#items', window.opener.document).append(newOption).trigger('change');
                    });

                    $('#items', window.opener.document).trigger('change');
                    window.opener.abcsetup.rfq.bid_requests.common.updateDeadNetPricing();
                    window.opener.abcsetup.rfq.bid_requests.common.updateAnnualUsage();
                    window.opener.abcsetup.rfq.bid_requests.common.updateQtyNeeded();
                    window.opener.abcsetup.rfq.bid_requests.common.updateAdditionalUsage();
                    window.opener.abcsetup.rfq.bid_requests.common.updateIncumbentSuppliers();
                    window.close();
                }
            });
        });

        // Cancel button clicked
        $(document).on('click', '.btn-cancel', function() {
            window.close();
        });

        // Init the exist items datatable
        this.initDataTable();
    },

    /**
     * Init the exist items datatable
     */
    initDataTable: function() {
        // Init datatables
        abcsetup.blockUI(true);
        window.opener.abcsetup.rfq.bid_requests.common.items = [];
        window.opener.abcsetup.rfq.bid_requests.common.removeItems = [];

        // Populate selected checkboxes in the array
        $("#items", window.opener.document).find("option:selected").each(function() {
            window.opener.abcsetup.rfq.bid_requests.common.items.push({
                id: $(this).val(),
                text: '(' + $(this).val() + ') ' + $(this).text()
            });
        });

        abcsetup.datatables.init($('table#existing_items'), {
            bInfo: true,
            scroll_horizontal: true,
            "responsive": false,
            "lengthMenu": [[5, 10, 25, 50, 100, 1000], [5, 10, 25, 50, 100, 1000]],
            "iDisplayLength": 5,
            dom: 'lftipB',
            "order": [[25, "asc"]],
            stateSave: false,
            serverSide: true,
            scrollY: '65vh',
            scrollX: true,
            resetTable: false,
            searchVisible: false, // Done search hidden columns, unless 'searchable' is set
            reorderRedraw: true, // Redraw the table when a column re-order happens

            ajax: "/api/coupa/datatable",
            columns: [
                { name: 'checkbox', orderable: false, searchable: false },
                { name: 'abc8' },
                { name: 'ndc' },
                { name: 'ndcmultipleproductflag' },
                { name: 'ndcmultipleproductdesc', visible: false },
                { name: 'itemdesc' },
                { name: 'itemstatuscode' },
                { name: 'strength' },
                { name: 'form' },
                { name: 'size' },
                { name: 'itemdescfull', visible: false },
                { name: 'unitdosesap', visible: false },
                { name: 'metricsize', visible: false },
                { name: 'equivalentmetricsize', visible: false },
                { name: 'caseqty', visible: false },
                { name: 'packagetype', visible: false },
                { name: 'catmgrname', visible: false },
                { name: 'buyername', visible: false },
                { name: 'compareto' },
                { name: 'gcnseqnumber', visible: false },
                { name: 'gcndesc' },
                { name: 'gcndescfull', visible: false, searchable: true },
                { name: 'gpn' },
                { name: 'gcn' },
                { name: 'gsn' },
                { name: 'prxoitemstatus' },
                { name: 'program', visible: false },
                { name: 'materialgroup', visible: false },
                { name: 'materialpricinggroup', visible: false },
                { name: 'fedcontrolid', visible: false },
                { name: 'vendor8' },
                { name: 'vendorname' },
                { name: 'swpabclistflag', visible: false },
                { name: 'swp_abclist', visible: false },
                { name: 'supernet', visible: false },
                { name: 'wac' },
                { name: 'contractcost' },
                { name: 'contractcostoverride', visible: false },
                { name: 'netcost' },
                { name: 'deadnetcost' },
                { name: 'globalmarketprice' },
                { name: 'genericlaunchdate', visible: false },
                { name: 'therapeuticclass', visible: false },
                { name: 'ahfsclass', visible: false },
                { name: 'fdbcolor', visible: false },
                { name: 'fdbshape', visible: false },
                { name: 'fdbflavor', visible: false },
                { name: 'fdborangebook', visible: false },
                { name: 'wag' },
                { name: 'agflag', visible: false },
                { name: 'routedesc', visible: false },
                { name: 'injectableflag', visible: false },
                { name: 'gcnnti', visible: false },
                { name: 'seasonalgcn', visible: false },
                { name: 'brandflag', visible: false },
                { name: 'costcoawardflag', visible: false },
                { name: 'flatload', visible: false },
                { name: 'priceonvizient', visible: false },
                { name: 'priceontexasmedicaid', visible: false },
                { name: 'top5080', visible: false },
                { name: 'inventorydate' },
                { name: 'forecast' },
                { name: 'unitsonhand' },
                { name: 'daysonhand' },
                { name: 'unitsonorder' },
                { name: 'daysonorder', visible: false },
                { name: 'map', visible: false },
                { name: 'gpinumber', visible: false },
                { name: 'gpiopiodflag', visible: false },
                { name: 'gpiopiodname', visible: false },
                { name: 'contractgp', visible: false },
                { name: 'deadnetgp', visible: false },
                { name: 'netgp', visible: false },
                { name: 'salesperiodmonth', visible: false },
                { name: 'monthly_non_prxo_contract_cost_sales', visible: false },
                { name: 'monthly_non_prxo_invoice_sales', visible: false },
                { name: 'monthly_non_prxo_quantity' },
                { name: 'monthly_prxo_contract_cost_sales', visible: false },
                { name: 'monthly_prxo_invoice_sales', visible: false },
                { name: 'monthly_prxo_quantity' },
                { name: 'monthtodate', visible: false },
                { name: 'salesperioddaily', visible: false },
                { name: 'mtd_non_prxo_contract_cost_sales', visible: false },
                { name: 'mtd_non_prxo_invoice_sales', visible: false },
                { name: 'mtd_non_prxo_quantity', visible: false },
                { name: 'mtd_prxo_contract_cost_sales', visible: false },
                { name: 'mtd_prxo_invoice_sales', visible: false },
                { name: 'mtd_prxo_quantity', visible: false },
                { name: 'material', visible: false },
                { name: 'abc6', visible: false },
                { name: 'hdsitemnumber', visible: false },
                { name: 'pmgnitemstatus' },
                { name: 'pmgncontractcost' },
                { name: 'pmgndeadnetcost5' },
            ],

            // Table has been drawn/paginated
            "drawCallback": function(settings) {
                // Check any selected item checkboxes
                $(window.opener.abcsetup.rfq.bid_requests.common.items).each(function() {
                    $('#existing_items input:checkbox[value=' + this.id + ']').addClass('selected').prop('checked', true);
                });

                var total = this.api().page.info().recordsDisplay;
                $('.btn-attach-all').html("Select All (" + abcsetup.addCommas(total) + ")").attr('disabled', true);

                if (total < 2000) {
                    $('.btn-attach-all').attr('disabled', false);
                }
            }
        });

        // Apply filters if the formulary type is specified - Commented out the below code as part of a smartsheet item in the rfq v2 epic
        // if ($('#formulary_type', window.opener.document).val()) {
        //     if ($('#formulary_type', window.opener.document).val() === 'PRxO') {
        //         // Filter prxoitemstatus to records that PGN or PGI
        //         abcsetup.datatables.table.column('25').search('^(PGN|PGI)', true, true).draw();
        //     } else {
        //         // Filter pmgnitemstatus to records that PMG or PMI
        //         abcsetup.datatables.table.column('91').search('^(PMG|PMI)', true, true).draw();
        //     }
        // }

        // Apply filters if the GCN family is specified
        if ($('#gcn_family', window.opener.document).val()) {
            let gcndesc = $('#gcn_family option:selected', window.opener.document).data('gcndesc');
            let form = $('#gcn_family option:selected', window.opener.document).data('form');

            if (gcndesc !== 'Various') {
                gcndesc = gcndesc.replace('(', '\\(');
                gcndesc = gcndesc.replace(')', '\\)');

                form = form.replace(')', '\\)');
                form = form.replace(')', '\\)');

                //abcsetup.datatables.table.search(gcndesc, true, true);
                abcsetup.datatables.table.column('20').search('^' + gcndesc, true, true);
                abcsetup.datatables.table.column('8').search(form).draw();
            }
        }
    },
}
